var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "input-group" },
        [
          _c("div", { staticClass: "input-group-prepend" }, [
            _c(
              "div",
              { staticClass: "input-group-text" },
              [_c("ItpIcon", { attrs: { icon: "ic:baseline-cable" } })],
              1
            )
          ]),
          _vm._v(" "),
          _c("ItpFormSelect2", {
            attrs: {
              name: "source",
              "bind-object": "",
              options: _vm.sources,
              valueField: "value",
              textField: "name",
              clearable: "",
              readonly: _vm.readonly
            },
            on: {
              input: function($event) {
                return _vm.evh_5962862420439144_input($event, {})
              }
            },
            model: {
              value: _vm.item.source,
              callback: function($$v) {
                _vm.$set(_vm.item, "source", $$v)
              },
              expression: "item.source"
            }
          }),
          _vm._v(" "),
          _c("ItpFormSelect", {
            attrs: {
              name: "rate_source",
              options: _vm.rateSources,
              valueField: "value",
              textField: "name",
              clearable: "",
              "null-option": "",
              readonly: _vm.readonly
            },
            on: {
              input: function($event) {
                return _vm.evh_8358196963355853_input($event, {})
              }
            },
            model: {
              value: _vm.item.rate_source,
              callback: function($$v) {
                _vm.$set(_vm.item, "rate_source", $$v)
              },
              expression: "item.rate_source"
            }
          }),
          _vm._v(" "),
          _c("ItpFormInput", {
            attrs: {
              name: "invoice_description",
              readonly: _vm.readonly,
              placeholder: _vm._f("pgettext")(
                "Invoice description",
                "ExchangeRateSourceSpec"
              )
            },
            on: {
              input: function($event) {
                return _vm.evh_1048678296148443_input($event, {})
              }
            },
            model: {
              value: _vm.item.invoice_description,
              callback: function($$v) {
                _vm.$set(_vm.item, "invoice_description", $$v)
              },
              expression: "item.invoice_description"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }